import { HStack, VStack } from '@genial/components';
import { Spacing } from '@genial/design-tokens';
import React from 'react';

import { ColoredSkeleton } from '../../../../BatchTicket/components/DynamicAsset/components/AssetsLoading';
import { reportGeneratorTheme } from '../../../constants/theme';

const TAG_SKELETON_COUNT = 4;
const CARD_SKELETON_COUNT = 3;

const CategoryTagSkeleton: React.FC = () => (
  <ColoredSkeleton height="32px" width="96px" borderRadius="full" />
);

const SubCategoryCardSkeleton: React.FC<{ width: number }> = ({ width }) => (
  <VStack
    width={`${width}px`}
    minH="240px"
    p="inline.xxs"
    bg={reportGeneratorTheme.card.bg}
    borderRadius="md"
    borderWidth={1}
    borderColor={reportGeneratorTheme.card.borderColor}
    space="stack.xxxs"
    justifyContent="space-between"
    style={{
      shadowColor: 'transparent',
      shadowOpacity: 0,
      shadowRadius: 0,
      shadowOffset: { width: 0, height: 0 },
      elevation: 0,
      boxShadow: 'none',
    }}>
    <VStack width="full" space="stack.xxxs" flex={1} alignItems="flex-start">
      <ColoredSkeleton height="40px" width="40px" borderRadius="sm" />
      <HStack alignItems="center" space="inline.quarck" width="full">
        <ColoredSkeleton height="20px" width="55%" borderRadius="sm" />
        <ColoredSkeleton height="18px" width="40px" borderRadius="sm" />
      </HStack>
      <ColoredSkeleton height="14px" width="100%" borderRadius="sm" />
      <ColoredSkeleton height="14px" width="90%" borderRadius="sm" />
      <ColoredSkeleton height="14px" width="60%" borderRadius="sm" />
    </VStack>
    <ColoredSkeleton height="16px" width="55%" borderRadius="sm" />
  </VStack>
);

export const ReportCatalogSkeleton: React.FC = () => {
  const cardWidth = 320;

  return (
    <VStack width="full" space="stack.nano" flexShrink={0}>
      <HStack space={Spacing['inline.nano']} flexWrap="wrap">
        {Array.from({ length: TAG_SKELETON_COUNT }).map((_, index) => (
          <CategoryTagSkeleton key={`tag-skeleton-${index}`} />
        ))}
      </HStack>

      <HStack space={reportGeneratorTheme.carousel.gap}>
        {Array.from({ length: CARD_SKELETON_COUNT }).map((_, index) => (
          <SubCategoryCardSkeleton key={`card-skeleton-${index}`} width={cardWidth} />
        ))}
      </HStack>
    </VStack>
  );
};
